"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDeliveryUsageRefined = exports.buildDeliveryRefined = void 0;
const __1 = require("..");
const buildDeliveryRefined = (delivery) => ({
    ID: delivery.ID,
    metadata: {
        created: delivery.metadata.created,
        updated: delivery.metadata.updated,
    },
    code: delivery.code,
    location: delivery.location,
    intake: delivery.intake,
    mode: delivery.mode,
    course: delivery.course,
    program: delivery.program,
    customAttributes: delivery.customAttributes,
});
exports.buildDeliveryRefined = buildDeliveryRefined;
const buildDeliveryUsageRefined = (applications, precedents, arrangements) => ({
    applications: applications.map((application) => (0, __1.buildApplicationRefined)(application)),
    precedents: precedents.map((precedent) => (0, __1.buildPrecedentRefined)(precedent)),
    arrangements: arrangements.map((arrangement) => (0, __1.buildArrangementRefined)(arrangement)),
});
exports.buildDeliveryUsageRefined = buildDeliveryUsageRefined;
//# sourceMappingURL=DeliveryRefined.js.map